import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { catchError } from 'rxjs/operators';

import { EnvService } from '../env.service';
import { RivirHttp } from '../shared/services/rivir-http.service';
import { DomSanitizer } from "@angular/platform-browser";
import * as moment from 'moment';

export class TableauReport {
    workbook: string;
    project: string;
    url: string;
    username: string;
    workBookId: string;
    customReportUrl: string;
}

export class TableauTrustedTicket {
    ticket: string;
    site: string; 
    tableauServer: string;
}



@Injectable()
export class TableauService {

    constructor(
        private http: HttpClient,
        private env: EnvService,
        private sanitizer: DomSanitizer
    ) { }

    public async getUserDashboard( username : string ) : Promise<TableauReport> {

        const getUserDashboardUrl = `${this.env.rivirApiBaseUrl}/tableau/dashboard?username=${username}`;

        const userDashboard = await this.http
                  .get<TableauReport>(getUserDashboardUrl, RivirHttp.getHttpOptions())
                  .pipe(catchError(RivirHttp.handleError)).toPromise();

        return userDashboard;

    }

    public async removeDashboard( username: string ) : Promise<null> {

        const deleteDashboardUrl = `${this.env.rivirApiBaseUrl}/tableau/dashboard`;

        const options = RivirHttp.getHttpOptions( { username });
        await this.http
        .request( 'DELETE', deleteDashboardUrl, options)
        .pipe(catchError(RivirHttp.handleError)).toPromise();

        return;
    }


    public async setDashboard( username: string, view: string, workbook: string, workBookId: string, project: string, UpdatedBy: string, contentUrl: string, customReportUrl: string) : Promise<Object> {

        const setDashboardUrl = `${this.env.rivirApiBaseUrl}/tableau/dashboard`;

        const dashboard = {
            username: username.trim(),
            view,
            workbook,
            workBookId,
            project, 
            UpdatedBy, 
            contentUrl, 
            customReportUrl
        };
        const options = RivirHttp.getHttpOptions( { dashboard } );

        return await this.http
        .request( 'POST', setDashboardUrl, options)
        .pipe(catchError(RivirHttp.handleError)).toPromise();
    }


    public async getTrustedTicket() : Promise<TableauTrustedTicket> {

        const trustedTicketUrl = `${this.env.rivirApiBaseUrl}/tableau/getTrustedTicket`;
        const trustedTicket = await this.http
        .get<TableauTrustedTicket>(trustedTicketUrl, RivirHttp.getHttpOptions())
        .pipe(catchError(RivirHttp.handleError)).toPromise();

        return trustedTicket;
    }

    public async getServerURI() : Promise<string> {

        const trustedTicketUrl = `${this.env.rivirApiBaseUrl}/tableau/getTableauUri`;
        const trustedTicket = await this.http
        .get<string>(trustedTicketUrl, RivirHttp.getHttpOptions())
        .pipe(catchError(RivirHttp.handleError)).toPromise();

        return trustedTicket;
    }

    public async getAllWorkBooks(filter: string) : Promise<Array<any>> {

        const trustedTicketUrl = `${this.env.rivirApiBaseUrl}/tableau/getWorkBook?filter=${filter}`;
        const trustedTicket = await this.http
        .get<Array<any>>(trustedTicketUrl, RivirHttp.getHttpOptions())
        .pipe(catchError(RivirHttp.handleError)).toPromise();

        return trustedTicket;
    }

    public async getWorkBookById(workBookId: string) : Promise<string> {

        const trustedTicketUrl = `${this.env.rivirApiBaseUrl}/tableau/getWorkBookById/${workBookId}`;
        const trustedTicket = await this.http
        .get<string>(trustedTicketUrl, RivirHttp.getHttpOptions())
        .pipe(catchError(RivirHttp.handleError)).toPromise();

        return trustedTicket;
    }

    public async getWorkbookUrl( contentUrl ) : Promise<string> {

        const trusted = await this.getTrustedTicket();
        
        let workBookUrl;
        if (trusted && trusted.ticket){

        workBookUrl = trusted.site ?  
            `${trusted.tableauServer}/trusted/${trusted.ticket}/t/${trusted.site}/views/${contentUrl}` :
            `${trusted.tableauServer}/trusted/${trusted.ticket}/views/${contentUrl}`;
        }
        else {
            throw new Error('Unable to retrieve Tableau Trusted Ticket');
        }

        return workBookUrl;

    }


    async loadWorkBooks(filter){

        const getAllWorkbooksUrl = `${this.env.rivirApiBaseUrl}/tableau/getWorkBook?filter=${filter}`;

        const workbooks : any = await this.http
            .get(getAllWorkbooksUrl, RivirHttp.getHttpOptions())
            .pipe(catchError(RivirHttp.handleError)).toPromise();

        
        for( const obj of workbooks ) {
            obj.lastUpdatedDate = moment(obj.lastUpdatedDate).format("MM-DD-YYYY");
            if ( typeof obj.previewImage !== "string"){
            if (obj.previewImage?.data?.length == 0){
                obj.previewImage = "https://images.squarespace-cdn.com/content/v1/587670ef03596ec731de6e3d/1486276069386-ENNKG7EAXQBUZHPMEY37/Tableau+Logo.png";
            }
            else{
                let base64String = this.arrayBufferToBase64(obj.previewImage.data);
                obj.previewImage = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + base64String);
            }
            }
        };
        
        workbooks.sort(function(a, b) {
            return +new Date(b.lastUpdatedDate) - +new Date(a.lastUpdatedDate);
        });
        

        return workbooks;
    }

    arrayBufferToBase64(buffer) {
        let binary = '';
        let bytes = new Uint8Array(buffer);
        let len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
      } 

}
